import { render } from "./S510_TvsKundenListe.vue?vue&type=template&id=177af730&scoped=true&ts=true"
import script from "./S510_TvsKundenListe.vue?vue&type=script&lang=ts"
export * from "./S510_TvsKundenListe.vue?vue&type=script&lang=ts"

import "./S510_TvsKundenListe.vue?vue&type=style&index=0&id=177af730&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-177af730"]])

export default __exports__